import fireworksImg from '../images/fireworks.jpg';
export const designProjects = [
  {
    id: "design1",
    img: "https://portfolio-3e62a.web.app/images/thumbs/md/580x250-md.jpg",
    lgimg: "https://portfolio-3e62a.web.app/project_pages/cashback/580x250.jpg",
    pname: "Cashback Wednesday - Everest Casino",
    shortName: "Cashback Wednesday",
    desc: "This project was to promote a bonus offer to casino customers who've recently lost. My task was to create a visual that demonstrates giving back a portion of what the customer lost. Using a stock image as the base, I edited the poker chips to add the Everest Casino logo, after which I created a stamp effect to make the message stand out.",
    source_assets: [
      "https://portfolio-3e62a.web.app/project_pages/cashback/chips.jpg"
    ]
  },
  {
    id: "design2",
    img: "https://portfolio-3e62a.web.app/images/thumbs/md/turn-md.jpg",
    lgimg: "https://portfolio-3e62a.web.app/project_pages/rock/turn-it-up.jpg",
    pname: "Turn It Up - Betclic",
    shortName: "Turn It Up",
    desc: "This project was to promote two casino games that are themed on Rock 'n' Roll music. Using a combination of stock images and images provided by the games' creators, I created a visual of two bands competing to be the loudest in a gig-like atmosphere.",
    source_assets: [
      "https://portfolio-3e62a.web.app/project_pages/rock/stock-concert.jpg",
      "https://portfolio-3e62a.web.app/project_pages/rock/sm_speaker.jpg",
      "https://portfolio-3e62a.web.app/project_pages/rock/bands.png"
    ]
  },
  {
    id: "design3",
    img: "https://portfolio-3e62a.web.app/images/thumbs/md/fantasy-md.jpg",
    lgimg: "https://portfolio-3e62a.web.app/images/big/fantasy.jpg",
    pname: "February Fantasy Mission - Betclic",
    shortName: "February Fantasy Mission",
    desc: "For this asset, I combined images from 3 separate Casino games and added photoshop effects to make them blend together.",
    source_assets: []
  },
  {
    id: "design4",
    img: "https://portfolio-3e62a.web.app/images/thumbs/md/spy-md.jpg",
    lgimg: "https://portfolio-3e62a.web.app/images/big/spy_banner.jpg",
    pname: "10K Challenge - Monaco Casino",
    shortName: "10K Challenge",
    desc: "For this Project I was tasked with creating an asset with a James Bond feel to it, but without using images that are associated with the movie. Armed with two stock images, I achieved my goal by making the model unrecognisable and instead focusing the viewer's attention on the suit, posture as well as the gun barrel background which can be easily associated with James Bond. This campaign was aimed at existing casino customers.",
    source_assets: []
  },
  {
    id: "design5",
    img: "https://portfolio-3e62a.web.app/images/thumbs/md/timeline-md.jpg",
    lgimg: "https://portfolio-3e62a.web.app/images/big/carnival.jpg",
    pname: "100k Carnival - Everest Poker",
    shortName: "100K Carnival",
    desc: "This asset was created to promote a poker event. I combined a stock image, cards created in Adobe Illustrator and Photoshop effects.",
    source_assets: [fireworksImg]
  },
  {
    id: "design6",
    img: "https://portfolio-3e62a.web.app/images/thumbs/md/980x600-md.jpg",
    lgimg: "https://portfolio-3e62a.web.app/images/big/mobile600.jpg",
    pname: "Mobile Casino - Expekt",
    shortName: "Mobile Casino",
    desc: "In this asset I combined elements from several casino games to promote the Expekt.com casino app.",
    source_assets: []
  }
]